// @ts-expect-error Function is a valid type
// biome-ignore lint/complexity/noBannedTypes: Function is a valid type
export const isFunction = <T>(value: T): value is Function => {
  return typeof value === "function";
};
